import React, { useEffect, useRef, useState, useCallback } from 'react';
import { pageAtom, myNftBackAtom, metaMaskAtom, topMessageAtom } from '../../State';
import { useDaily, useParticipantIds, useRoom } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import './Header.css';
import { useTranslation } from 'react-i18next';

export default function CountDown({ isHome = false, roomID, leaveCall }) {
  //Daily系
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const remoteParticipantIds = useParticipantIds({ filter: 'remote' });

  //その他
  const [countDownState, setCountDownState] = useState('00:30:00');
  const [is5minState, set5minState] = useState(false);
  const [is1minState, set1minState] = useState(false);
  const intervalRef = useRef(null);
  const endDateRef = useRef(null);
  const isCountDownStarted = useRef(false);
  const { t } = useTranslation();

  const startCountDown = () => {
    if (intervalRef.current == null) {
      intervalRef.current = setInterval(() => {
        //今の日時
        const now = new Date();

        //終了時間の設定
        if (endDateRef.current == null) {
          endDateRef.current = now;
          endDateRef.current.setMinutes(now.getMinutes() + 30);
        }

        //  target.setMinutes(target.getMinutes() + 30);
        const remainTime = endDateRef.current.getTime() - now; //差分を取る（ミリ秒で返ってくる

        //指定の日時を過ぎていたら処理をしない
        if (remainTime < 0) {
          //ミーティング終了
          endMeeting();
          return false;
        }

        //差分の日・時・分・秒を取得
        // const difDay = Math.floor(remainTime / 1000 / 60 / 60 / 24);
        // const difHour = Math.floor(remainTime / 1000 / 60 / 60) % 24;
        const difMin = Math.floor(remainTime / 1000 / 60) % 60;
        const difSec = Math.floor(remainTime / 1000) % 60;

        //残りの日時を上書き
        // document.getElementById("countdown-day").textContent = difDay;
        // document.getElementById("countdown-hour").textContent = difHour;
        const finalMin = difMin < 10 ? '0' + difMin : difMin;
        const finalSec = difSec < 10 ? '0' + difSec : difSec;

        //残り5分以内の場合
        if (difMin <= 4 && difMin > 0 && is5minState == false) {
          setTopMessageState({ type: 'joined', message: '5 minutes left' });
          set5minState(true);
        }

        //残り1分以内の場合
        if (difMin <= 1 && difMin > 0 && is1minState == false) {
          setTopMessageState({ type: 'joined', message: '2 minute left' });
          set1minState(true);
        }

        setCountDownState('00:' + finalMin + ':' + finalSec);
      }, 1000);
    }
  };

  //ミーティング終了
  const endMeeting = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    leaveCall();
  };

  const clearState = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  useEffect(() => {
    //リモートユーザーが1人以上いる場合
    if (remoteParticipantIds.length > 0 && isCountDownStarted.current == false) {
      //カウントダウンスタート
      //startCountDown();
      //isCountDownStarted.current = true;

      (async () => {
        //アップデートルーム情報
        // const result = API.updateRoom(roomID);
        // if (result != null) {
        // }
      })();
    }

    return () => clearState;
  }, [remoteParticipantIds]);

  return (
    <>
      <div id="countDownWrap" className={is5minState ? 'is5minleft' : ''}>
        {/* {countDownState} */}
        {t('bottom.End Call')}
      </div>
    </>
  );
}
